import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useFormControl } from './utils.js';

var FormControl = function FormControl(props) {
  var as = props.as,
      className = props.className,
      onChange = props.onChange,
      dataValue = props.dataValue,
      name = props.name,
      onValueChange = props.onValueChange,
      setError = props.setError,
      type = props.type,
      valueChangeDelay = props.valueChangeDelay,
      valueOverride = props.valueOverride;

  var _useFormControl = useFormControl({
    as: as,
    className: className,
    dataValue: dataValue,
    name: name,
    onValueChange: onValueChange,
    onChange: onChange,
    setError: setError,
    type: type,
    valueChangeDelay: valueChangeDelay,
    valueOverride: valueOverride
  }),
      pattern = _useFormControl.pattern,
      newClassName = _useFormControl.newClassName,
      onBlur = _useFormControl.onBlur,
      onFormChange = _useFormControl.onFormChange,
      value = _useFormControl.value,
      input = _useFormControl.input;

  return /*#__PURE__*/React.createElement(Form.Control, _extends({}, props, {
    as: as,
    className: newClassName,
    "data-field": "input-field",
    onBlur: onBlur,
    onChange: onFormChange,
    onFocus: props.onFocus,
    pattern: pattern,
    ref: input,
    value: value
  }));
};

FormControl.displayName = "FormControl";
export { FormControl };